import React from 'react';
import { FadeIn } from './FadeIn';
import { X, Check, Search, Layers, TrendingUp, Target } from 'lucide-react';
export function MaquinaAdministrativa() {
  const comparisons = [{
    task: 'Diagnóstico',
    without: 'Salgo y veo qué pasa',
    with: 'Nivel real de carga y tolerancia identificado'
  }, {
    task: 'Estructura',
    without: 'Mismo trote todos los días',
    with: 'Sesiones organizadas por intensidad y recuperación'
  }, {
    task: 'Progresión',
    without: 'Sumo kilómetros y veo',
    with: 'Aumento gradual y medible semana a semana'
  }, {
    task: 'Decisión diaria',
    without: '¿Salgo o no salgo?',
    with: 'Semáforo del Dolor decide por vos'
  }, {
    task: 'Lesiones',
    without: 'Aparecen sin aviso',
    with: 'Detectadas antes de que pasen'
  }, {
    task: 'Resultado',
    without: 'Mismo tiempo durante meses',
    with: 'Mejorás semana a semana sin romperte'
  }];
  return <section className="py-8 md:py-16 px-4 max-w-5xl mx-auto" data-id="element-199">
      <FadeIn data-id="element-200">
        <div className="text-center mb-6 md:mb-12" data-id="element-201">
          <div className="inline-flex items-center justify-center w-14 h-14 md:w-20 md:h-20 rounded-full bg-[#22c55e]/10 mb-3 md:mb-6 border border-[#22c55e]/20 relative" data-id="element-202">
            <div className="absolute inset-0 bg-[#22c55e]/20 blur-xl rounded-full animate-pulse" data-id="element-203"></div>
            <Layers className="text-[#16a34a] relative z-10 w-7 h-7 md:w-10 md:h-10" data-id="element-204" />
          </div>
          <h2 className="text-2xl md:text-5xl font-black text-[#0f172a] mb-2 md:mb-4 px-2" data-id="element-205">
            EL PROTOCOLO DE CARGA SELECTIVA (PCS)
          </h2>
          <p className="text-sm md:text-xl text-[#475569] font-bold max-w-2xl mx-auto" data-id="element-206">
            Por qué Sistema Running Pro funciona cuando todo lo demás falló.
            Diagnóstico → Estructura → Progresión.
          </p>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mb-6 md:mb-12" data-id="element-207">
        <FadeIn delay={0.2} data-id="element-208">
          <div className="bg-[#ef4444]/5 border border-[#ef4444]/20 rounded-2xl p-4 md:p-8 h-full" data-id="element-209">
            <div className="flex items-center gap-3 mb-4 md:mb-8 pb-3 md:pb-4 border-b border-[#ef4444]/10" data-id="element-210">
              <div className="bg-[#ef4444]/10 p-1.5 md:p-2 rounded-lg" data-id="element-211">
                <X className="text-[#ef4444] w-5 h-5 md:w-6 md:h-6" data-id="element-212" />
              </div>
              <h3 className="text-base md:text-xl font-black text-[#ef4444]" data-id="element-213">
                Sin PCS
              </h3>
            </div>
            <div className="space-y-3 md:space-y-6" data-id="element-214">
              {comparisons.map((item, i) => <div key={i} className="flex flex-col gap-0.5 md:gap-1" data-id="element-215">
                  <span className="text-xs md:text-sm text-[#475569] font-bold" data-id="element-216">
                    {item.task}
                  </span>
                  <span className="text-base md:text-lg font-mono text-[#0f172a] font-medium" data-id="element-217">
                    {item.without}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-218">
          <div className="bg-white border-2 border-[#22c55e]/50 rounded-2xl p-4 md:p-8 h-full relative overflow-hidden shadow-[0_10px_30px_rgba(34,197,94,0.1)]" data-id="element-219">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#22c55e]/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-220"></div>

            <div className="flex items-center gap-3 mb-4 md:mb-8 pb-3 md:pb-4 border-b border-[#22c55e]/20 relative z-10" data-id="element-221">
              <div className="bg-[#22c55e] p-1.5 md:p-2 rounded-lg shadow-[0_0_15px_rgba(34,197,94,0.5)]" data-id="element-222">
                <Check className="text-[#020617] w-5 h-5 md:w-6 md:h-6" strokeWidth={3} data-id="element-223" />
              </div>
              <h3 className="text-base md:text-xl font-black text-[#16a34a]" data-id="element-224">
                Con PCS
              </h3>
            </div>
            <div className="space-y-3 md:space-y-6 relative z-10" data-id="element-225">
              {comparisons.map((item, i) => <div key={i} className="flex flex-col gap-0.5 md:gap-1" data-id="element-226">
                  <span className="text-xs md:text-sm text-[#475569] font-bold" data-id="element-227">
                    {item.task}
                  </span>
                  <span className="text-sm md:text-lg font-mono font-black text-[#020617] bg-[#22c55e]/20 w-fit px-2 md:px-3 py-0.5 md:py-1 rounded-md border border-[#22c55e]/30" data-id="element-228">
                    {item.with}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>

      <FadeIn delay={0.4} data-id="element-229">
        <div className="flex flex-wrap justify-center gap-2 md:gap-6" data-id="element-230">
          <div className="flex items-center gap-1.5 md:gap-2 bg-white border border-[#e2e8f0] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold text-[#0f172a] shadow-sm" data-id="element-231">
            <Search size={14} className="text-[#22c55e]" data-id="element-232" /> Diagnóstico
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-white border border-[#e2e8f0] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold text-[#0f172a] shadow-sm" data-id="element-233">
            <Layers size={14} className="text-[#22c55e]" data-id="element-234" /> Estructura
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-white border border-[#e2e8f0] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold text-[#0f172a] shadow-sm" data-id="element-235">
            <TrendingUp size={14} className="text-[#22c55e]" data-id="element-236" /> Progresión
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-white border border-[#e2e8f0] px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold text-[#0f172a] shadow-sm" data-id="element-237">
            <Target size={14} className="text-[#22c55e]" data-id="element-238" /> Resultado real
          </div>
        </div>
        <p className="text-center text-sm md:text-base text-[#16a34a] font-black mt-3 md:mt-6" data-id="element-239">
          No es magia. Es lógica aplicada al rendimiento humano.
        </p>
      </FadeIn>
    </section>;
}